<div class="group bg-card flex h-full cursor-pointer flex-col overflow-hidden rounded-2xl shadow transition-shadow duration-200 hover:shadow-lg"
    *transloco="let t; prefix: translationPrefix()">
    <!-- En-tête de la vignette -->
    <div class="flex items-center justify-between p-3 pb-0">
        <div class="flex items-center">
            <div class="line-clamp-2 text-lg font-semibold leading-tight">
                {{ displayName | transloco }}
            </div>
        </div>

        <!-- Boutons d'actions -->
        @if (showActions()) {
        <div class="flex items-center space-x-1">
            <mat-icon svgIcon="heroicons_mini:user-circle" [class.text-primary]="dashboard().isOwner"
                [class.text-gray-200]="!dashboard().isOwner" />
            @if (showPreferredButton()) {
            <button mat-icon-button (click)="onTogglePreferred()"
                [matTooltip]="isPreferred() ? t('actions.remove-from-preferred') : t('actions.add-to-preferred')"
                class="hover:bg-primary/10"
                [ngClass]="{ 'opacity-20 transition-opacity duration-200 group-hover:opacity-100': !isPreferred(), }">
                <mat-icon [svgIcon]="isPreferred() ? 'heroicons_solid:star' : 'heroicons_outline:star'"
                    class="icon-size-5" [class.text-yellow-500]="isPreferred()" />
            </button>
            }
        </div>
        }
    </div>
    @if (showThematic()) {
    <div class="flex gap-2 px-3 text-xs text-gray-400">
        <span>{{dashboard().subSectorName}}</span>
        <span>/</span>
        <span>{{dashboard().thematicName}}</span>
    </div>
    }

    <!-- Contenu de la vignette -->
    <div class="flex flex-auto flex-col p-3 pt-0" matTooltipPosition="below">
        <div class="text-secondary mt-2 line-clamp-2 text-sm">
            {{ displayDescription | transloco }}
        </div>
    </div>

    <!-- Footer avec statistiques -->
    <div class="border-t p-3 pt-1">
        <div class="text-secondary flex items-center justify-between space-x-4 text-sm">
            <div class="flex items-center">
                <mat-icon svgIcon="insert_chart" class="mr-1" color="primary" />
                <div>{{ dashboard().graphicsCount }}</div>
            </div>
            <div class="flex items-center space-x-1 opacity-20 transition-opacity duration-200 group-hover:opacity-100">
                @if (dashboard().canShare) {
                <button mat-icon-button (click)="onShare(); $event.stopPropagation()"
                    matTooltip="{{ t('actions.share') }}" class="hover:bg-primary/10">
                    <mat-icon svgIcon="heroicons_outline:share" class="icon-size-5"
                        [class.text-primary]="dashboard().isShared" />
                </button>
                }
                @if (dashboard().canEdit) {
                <button mat-icon-button (click)="onEditDesign(); $event.stopPropagation()"
                    matTooltip="{{ t('actions.edit-design') }}" class="hover:bg-primary/10">
                    <mat-icon svgIcon="heroicons_outline:squares-2x2" class="icon-size-5" />
                </button>
                }
                @if (dashboard().canEdit) {
                <button mat-icon-button (click)="onEdit(); $event.stopPropagation()"
                    matTooltip="{{ t('actions.rename') }}" class="hover:bg-primary/10">
                    <mat-icon svgIcon="heroicons_outline:pencil" class="icon-size-5" />
                </button>
                }
                @if (dashboard().canDelete) {
                <button mat-icon-button color="warn" (click)="onDelete(); $event.stopPropagation()"
                    matTooltip="{{ t('actions.delete') }}" class="text-red-600 hover:bg-red-50">
                    <mat-icon svgIcon="heroicons_outline:trash" class="icon-size-5" />
                </button>
                }
            </div>
        </div>
    </div>
</div>